export const modalMaxWidth = "800px";
export const modalHuge = "6xl";
